// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Noto_Sans_TC_122055', '__Noto_Sans_TC_Fallback_122055'","fontStyle":"normal"},"className":"__className_122055","variable":"__variable_122055"};